import { Component, Input } from '@angular/core';
import { BaseDeviceActivation } from '../cellular-device-activation/base-device-activation';
import { IDictionary } from '../dictionary/IDictionary';
import { CellularDeviceDeactivationService } from './cellular-device-deactivation.service';

@Component({
    selector: 'cl-cellular-device-deactivation',
    templateUrl: './cellular-device-deactivation.component.html'
})
export class CellularDeviceDeactivationComponent extends BaseDeviceActivation {
    public static $name: string = 'clCellularDeviceDeactivation';

    @Input() allowedMobileIdTypes: CASLink.Device.Ui.ViewModel.Modules.MobileIdTypeViewModel[];
    @Input() canRequestDeactivation: boolean;
    @Input() cellularDeviceStatus: CASLink.Device.Ui.ViewModel.Modules.CellularDeviceStatusViewModel;
    @Input() carrier: CASLink.Device.Ui.ViewModel.Modules.CellularCarrierViewModel;
    @Input() deviceIdentifierMap: IDictionary<string>;
    @Input() jobNumber: number;
    @Input() locationId: number;
    @Input() moduleId: number;
    @Input() vendor: CASLink.Device.Ui.ViewModel.Modules.CellularVendorViewModel;

    constructor(
        private cellularDeviceDeactivationService: CellularDeviceDeactivationService
    ) {
        super();
    }

    public deactivate() {
        this.prepareRequest();
        this.cellularDeviceDeactivationService
            .sendDeactivationRequest(this.cellularDeviceActivationViewModel)
            .then(() => {
                this.canRequestDeactivation = false;
            });
    }

    public deviceExist(): boolean {
        return this.cellularDeviceStatus !== null && this.cellularDeviceStatus !== undefined;
    }

    public isActive(): boolean {
        return this.deviceExist() && this.cellularDeviceStatus.isActive;
    }
}
